import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './cons-cloture-motif-type.reducer';
import { IConsClotureMotifType } from 'app/shared/model/cons-cloture-motif-type.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model';

export const ConsClotureMotifTypeUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const consClotureMotifTypeEntity = useAppSelector(state => state.consClotureMotifType.entity);
  const loading = useAppSelector(state => state.consClotureMotifType.loading);
  const updating = useAppSelector(state => state.consClotureMotifType.updating);
  const updateSuccess = useAppSelector(state => state.consClotureMotifType.updateSuccess);
  const statusValues = Object.keys(Status);

  const handleClose = () => {
    props.history.push('/cons-cloture-motif-type');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...consClotureMotifTypeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ACTIVE',
          ...consClotureMotifTypeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.consClotureMotifType.home.createOrEditLabel">
            <Translate contentKey="almobadaraMasterDataApp.consClotureMotifType.home.createOrEditLabel">
              Create or edit a ConsClotureMotifType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cons-cloture-motif-type-id"
                  label={translate('almobadaraMasterDataApp.consClotureMotifType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.consClotureMotifType.name')}
                id="cons-cloture-motif-type-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.consClotureMotifType.nameAr')}
                id="cons-cloture-motif-type-nameAr"
                name="nameAr"
                data-cy="nameAr"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.consClotureMotifType.nameEn')}
                id="cons-cloture-motif-type-nameEn"
                name="nameEn"
                data-cy="nameEn"
                type="text"
              />
              <ValidatedField
                id="cons-cloture-motif-type-status"
                name="status"
                data-cy="status"
                label={translate('almobadaraMasterDataApp.consClotureMotifType.status')}
                type="select"
              >
                {statusValues.map(value => (
                  <option value={value} key={value}>
                    {translate(`almobadaraMasterDataApp.Status.${value}`)}
                  </option>
                ))}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/cons-cloture-motif-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />{' '}
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.cancel">Cancel</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entitySaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" /> <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ConsClotureMotifTypeUpdate;
